import classNames from 'classnames';
import React from 'react';
import { Img } from 'react-image';
import { MeetingType, UIRoundTemplate } from 'types';

interface TechStackIconProps {
	roundTemplate: UIRoundTemplate;
	setSelectedTechStack: (val: string) => void;
	setIsAIRoundSelected: (val: boolean) => void;
	selectedTeckStack: string;
}

export const TechStackIcon = ({
	roundTemplate,
	setSelectedTechStack,
	selectedTeckStack,
	setIsAIRoundSelected,
}: TechStackIconProps) => {
	return (
		<div
			onClick={() => {
				setSelectedTechStack(roundTemplate._id);
				setIsAIRoundSelected(
					roundTemplate.isAIInterviewTemplate || roundTemplate.templateType === MeetingType.Assessment,
				);
			}}
			className={classNames(
				'flex px-[12px] py-[8px] cursor-pointer rounded-lg border w-max',
				selectedTeckStack === roundTemplate._id
					? 'bg-[#18222D] border border-[#7777E7] text-[#FFFFFF]'
					: 'bg-[#F2F2F5] text-[#1C1C28]',
			)}
		>
			<Img src={roundTemplate.techStack.iconsUrl ?? ''} className="h-6 w-6" alt={roundTemplate.title} />
			<div className="pl-1.5">{roundTemplate.title}</div>
		</div>
	);
};
